import { useMutation } from '@apollo/client';
import { queries } from './queries';

const useRemoveAnswerCounter = () =>
  useMutation(queries.removeAnswerCounter, {
    errorPolicy: 'all', // ingore errors since we don't have to manage errors for this call
  });

export default useRemoveAnswerCounter;
